import { geographiesApi } from "apis";
import { Country, State } from "models/Geography";
import React, { createContext, useEffect } from "react";

interface Props {
  children: JSX.Element;
}

export interface GeographyContextInterface {
  countries?: Country[],
  states?: State[]
}

export const GeographyContext = createContext<GeographyContextInterface>({
  countries: undefined,
  states: undefined,
});

export const GeographyContextWrapper = ({ children }: Props): JSX.Element => {
  const [countries, setCountries] = React.useState<Country[]|undefined>()
  const [states, setStates] = React.useState<State[]|undefined>()

  useEffect(() => {
    console.log("fetching countries and states")
    geographiesApi.fetchCountries().then(countries => {
      if(countries) {
        setCountries(countries)
      } else {
        setCountries([]) // Using [] so we know we fetched versus undefined where we won't know
      }
    })
    geographiesApi.fetchStates().then(states => {
      if(states) {
        setStates(states)
      } else {
        setStates([]) // Using [] so we know we fetched versus undefined where we won't know
      }
    })
  }, [])

  return (
    <GeographyContext.Provider
      value={{
        countries,
        states,
      }}
    >
      {children}
    </GeographyContext.Provider>
  );
};
